import memoize from 'lru-memoize';

import {globalWindow} from '../../libs/shared/helpers/src/browser/browserHelpers';
import {isMobile} from '../../libs/shared/helpers/src/environment/mobileEnvHelpers';

// TODO: Migrate usages of debug to logger.
declare global {
  interface Window {
    mute: () => void;
    unmute: () => void;
    grep: (query: string) => void;
  }
}

let verbose = true;

export function mute() {
  verbose = false;
}

globalWindow.mute = mute;

export function unmute() {
  verbose = true;
}

globalWindow.unmute = unmute;

export function info(...args: Array<any>) {
  if (verbose) {
    console.log(...args);
  }
}

const enabledDebugFeatures = memoize()(() =>
  isMobile() ? [''] : JSON.parse(localStorage.getItem('front-debug-features') || '[]'),
);
export const hasDebugFeature = memoize(20)((feature: DebuggableFeature) =>
  enabledDebugFeatures().includes(feature),
);

type DebuggableFeature = 'offline' | 'serviceWorker' | 'ui-sdk' | 'palette-scores';

const featureColor = new Map<DebuggableFeature, string>([
  ['offline', '#D66951'],
  ['serviceWorker', '#8C5EC9'],
  ['ui-sdk', '#839788'],
]);

/**
 * Prints a debug console statement if the feature debugging is enabled in localStorage.
 * Example to enable the offline debugging: localStorage.setItem('front-debug-features', '["offline"]'); then reload your app.
 */
export function debug(feature: DebuggableFeature, ...args: Array<any>) {
  if (hasDebugFeature(feature)) {
    console.debug(`%c${feature} -`, `color: ${featureColor.get(feature)}; font-weight: 600;`, ...args);
  }
}

export interface TraceEvent {
  name: string;
  ts: number;
  data: any;
}

const scrollBack: Array<TraceEvent> = [];
const maxScroll = 5000;

export function trace(name: string, event: any) {
  scrollBack.push({name, ts: Date.now(), data: event});

  if (scrollBack.length > maxScroll) {
    scrollBack.splice(0, maxScroll / 2);
  }
}

export function grep(query: any) {
  const queryStr = String(query);
  let hadMatch = false;

  // Automatically convert conversation IDs.
  const queryAltMatch = /^cnv_(\w+)$/.exec(queryStr);
  const queryAlt = queryAltMatch ? parseInt(queryAltMatch[1], 36).toString() : undefined;

  scrollBack.forEach((e) => {
    const jsonData = JSON.stringify(e.data);
    const isMatch =
      e.name.includes(queryStr) || jsonData.includes(queryStr) || (queryAlt && jsonData.includes(queryAlt));
    const isNetworkEvent = e.name === 'network-status' || e.name === 'push-status';

    // Log all matching events + subsequent network events because they might resyncs.
    if (isMatch || (hadMatch && isNetworkEvent)) {
      console.log(new Date(e.ts), e.name, e.data);
    }

    if (isMatch) {
      hadMatch = true;
    }
  });
}

globalWindow.grep = grep;
